import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { useDonation } from "@/context/DonationContext";

/**
 * Mobile-only floating "Doar agora" button. Appears after scrolling past the hero.
 */
export default function MobileDoarFab() {
  const { openModal } = useDonation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`md:hidden fixed left-4 right-4 bottom-4 z-40 transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8 pointer-events-none"
      }`}
      data-testid="mobile-doar-fab"
    >
      <button
        type="button"
        onClick={() => openModal("mobile-fab")}
        data-testid="mobile-doar-fab-btn"
        className="flex items-center justify-center gap-2 w-full rounded-full bg-ga-emerald text-white font-bold py-4 shadow-2xl"
      >
        <Heart className="w-5 h-5 fill-white" />
        Doar agora
      </button>
    </div>
  );
}
